import { createPortal } from 'react-dom';

const portalRoot = document.getElementById('portal-root');

const Portal = ({ children }) => createPortal(children, portalRoot);

export default Portal;
